import script from "./BulkProvisioningConfirmModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./BulkProvisioningConfirmModal.vue?vue&type=script&setup=true&lang=ts"

import "./BulkProvisioningConfirmModal.vue?vue&type=style&index=0&id=64e15440&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64e15440"]])

export default __exports__